import { defineStore } from 'pinia'
import { getMeta, setMeta, NetworkError } from '@addictivegroup/addictive-offline'
import { api } from '@/lib/http.js'
import { offline } from '@/lib/offline.js'
import { plain } from '@/lib/plain.js'

/** People and groups of the tenant (from AddZone, mirrored by Core), for pickers and mentions. */
export const useDirectory = defineStore('directory', {
  state: () => ({ users: [], groups: [], loaded: false }),
  actions: {
    async load({ force = false } = {}) {
      if (this.loaded && !force) return
      try {
        const [users, groups] = await Promise.all([api('/directory/users'), api('/directory/groups')])
        this.users = users.data
        this.groups = groups.data
        await setMeta(offline.db, 'crm_directory', plain({ users: this.users, groups: this.groups }))
      } catch (error) {
        if (!(error instanceof NetworkError)) throw error
        const cached = await getMeta(offline.db, 'crm_directory')
        if (cached) Object.assign(this, cached)
      }
      this.loaded = true
    },
    user(uuid) {
      return this.users.find((u) => u.uuid === uuid) || null
    },
    group(uuid) {
      return this.groups.find((g) => g.uuid === uuid) || null
    },
  },
})
